export default __webpack_public_path__ + "static/media/DashboardSVG.a6f6950e.svg";